// extracted by mini-css-extract-plugin
export default {"root":"vfHNgus8K8cyNxfSXk_g","landscape":"bzxnCcBDYK9KL96_Mf0E","wrapper":"_5ebJ2XIEUQfs52SQUGg","listWrapper":"HCFDvhClIUDP9KiRYbJm","divider":"XsutM8AXf_H0gXkdVGTf"};